import {FC} from 'react';
import {Trans, useTranslation} from 'react-i18next';
import Link from 'components/Link';
import {PdfFilenameElementOption} from '../../types';

type PdfFilenameComponentNameProps = {
    element: PdfFilenameElementOption;
};

const PdfFilenameComponentName: FC<PdfFilenameComponentNameProps> = ({
    element,
}) => {
    const {t} = useTranslation('Document.PdfFilenameSettings');

    if (element === 'document_type_legacy')
        return (
            <Trans
                components={[
                    <Link
                        key={0}
                        href="https://help.makeleaps.jp/ja/articles/8059992"
                        isOpenInNewTab={true}
                    >
                        {' '}
                    </Link>,
                ]}
                i18nKey={`element.${element}`}
                t={t}
            />
        );

    return <>{t(`element.${element}`)}</>;
};

export default PdfFilenameComponentName;
